import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';
import Stack from '../Stack/index.js';
import { Section, MainContentArea, DesktopImg, MobileImg, ModuleArea, BackgroundImage, MobileBackgroundImage } from './SplitModule.styles.js';

var _excluded = ["alignMainContent", "alignImageToBottom", "mobileAlignImageToBottom", "image", "mainContent", "children", "backgroundColor", "splitBackgroundColor", "backgroundImage", "mobileBackgroundImage", "textColor", "mobileTextColor", "topPadding", "bottomPadding", "width"];
var SplitModule = function SplitModule(_ref) {
  var alignMainContent = _ref.alignMainContent,
    alignImageToBottom = _ref.alignImageToBottom,
    mobileAlignImageToBottom = _ref.mobileAlignImageToBottom,
    image = _ref.image,
    mainContent = _ref.mainContent,
    children = _ref.children,
    backgroundColor = _ref.backgroundColor,
    splitBackgroundColor = _ref.splitBackgroundColor,
    backgroundImage = _ref.backgroundImage,
    mobileBackgroundImage = _ref.mobileBackgroundImage;
    _ref.textColor;
    _ref.mobileTextColor;
    var topPadding = _ref.topPadding,
    bottomPadding = _ref.bottomPadding,
    width = _ref.width,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Section, _extends({
    className: "leshen-split-module",
    splitBackgroundColor: splitBackgroundColor,
    alignMainContent: alignMainContent,
    alignImageToBottom: alignImageToBottom,
    hasBackgroundColorOrImage: backgroundColor || Boolean(backgroundImage),
    mobileAlignImageToBottom: mobileAlignImageToBottom,
    topPadding: topPadding,
    bottomPadding: bottomPadding,
    width: width
  }, props), /*#__PURE__*/React.createElement(MainContentArea, {
    className: "main-content-area",
    splitBackgroundColor: splitBackgroundColor,
    topPadding: topPadding,
    bottomPadding: bottomPadding,
    width: width
  }, /*#__PURE__*/React.createElement(Stack, {
    className: "stack",
    alignMainContent: alignMainContent
  }, !alignImageToBottom && /*#__PURE__*/React.createElement(DesktopImg, null, image), !mobileAlignImageToBottom && /*#__PURE__*/React.createElement(MobileImg, null, image), mainContent, alignImageToBottom && /*#__PURE__*/React.createElement(DesktopImg, null, image), mobileAlignImageToBottom && /*#__PURE__*/React.createElement(MobileImg, null, image))), /*#__PURE__*/React.createElement(ModuleArea, {
    className: "module-area background-color-".concat(backgroundColor || 'default'),
    backgroundColor: backgroundColor,
    hasBackgroundImage: Boolean(backgroundImage),
    topPadding: topPadding,
    bottomPadding: bottomPadding,
    width: width
  }, backgroundImage && /*#__PURE__*/React.createElement(BackgroundImage, {
    mobileBackgroundImage: mobileBackgroundImage
  }, backgroundImage), mobileBackgroundImage && /*#__PURE__*/React.createElement(MobileBackgroundImage, null, mobileBackgroundImage), children));
};
var SplitModule$1 = SplitModule;

export { SplitModule$1 as default };
//# sourceMappingURL=index.js.map
